import {
  clearConversations,
  fetchConversationByEntity,
  loadMoreConversationsByEntity,
} from '../routines/conversationRoutines';

const initialState = {
  conversations: [],
  conversationFetchLoading: false,
  conversationFetchError: false,
  conversationPaginationData: {},
  loadingMore: false,
};

const conversationReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchConversationByEntity.TRIGGER:
      return {
        ...state,
        conversationFetchLoading: true,
        conversationFetchError: false,
      };
    case loadMoreConversationsByEntity.TRIGGER:
      return {
        ...state,
        loadingMore: true,
        conversationFetchError: false,
      };
    case fetchConversationByEntity.SUCCESS: {
      return {
        ...state,
        conversationFetchLoading: false,
        conversations: action.payload.conversations || [],
        conversationPaginationData: {
          hasMOreConversations: action.payload?.hasMore,
          lastConversationModifiedDate:
            action.payload?.lastModifiedDate || new Date(),
        },
      };
    }
    case loadMoreConversationsByEntity.SUCCESS: {
      return {
        ...state,
        conversationFetchLoading: false,
        loadingMore: false,
        conversations: [
          ...state.conversations,
          ...(action.payload?.conversations || []),
        ],
        conversationPaginationData: {
          hasMOreConversations: action.payload?.hasMore,
          lastConversationModifiedDate:
            action.payload?.lastModifiedDate || new Date(),
        },
      };
    }
    case fetchConversationByEntity.FAILURE:
      return {
        ...state,
        conversationFetchLoading: false,
        conversationFetchError: true,
      };
    case clearConversations.TRIGGER: {
      return {
        ...state,
        conversations: [],
        conversationFetchLoading: false,
        conversationFetchError: false,
        conversationPaginationData: {},
      };
    }
    case loadMoreConversationsByEntity.FAILURE:
      return {
        ...state,
        loadingMore: false,
        conversationFetchError: true,
      };
    default:
      return state;
  }
};

export default conversationReducer;
